<div class="c11n-space-stack-10x c11n-space--force"></div>

<div class="container">
    <div class="row d-flex justify-content-center g-0 mx-auto c11n-space-stack-6x">
        <div class="col-md-12 col-lg-6">
            <div class="c11n-space-stack-6x">
                <h1 class="c11n-text-xl-headline" data-cy="almost-there-page-heading">
                    {{ heading }}
                </h1>
            </div>

            <div class="row">
                <div class="col-3 col-md-2 col-lg-2 d-flex justify-content-start">
                    <ng-container *ngIf="isInformationOnly$ | async; else limitedFlow">
                        <img
                            src="../../../../../assets/info-only-flow-almost-there.svg"
                            alt=""
                            data-cy="almost-there-checklist-icon"
                        />
                    </ng-container>
                    <ng-template #limitedFlow>
                        <img
                            src="../../../../../assets/limited-flow-almost-there.svg"
                            alt=""
                            data-cy="almost-there-checklist-icon"
                        />
                    </ng-template>
                </div>

                <div class="col-9 col-md-10 col-lg-10">
                    <div class="row full-height">
                        <div
                            class="col-12 col-md-12 d-flex flex-column justify-content-between c11n-space-inset-1x"
                        >
                            <div
                                class="c11n-text-md col-lg-10 not-active-step step"
                                data-cy="set-up-online-access-list-item"
                                [aria-label]="stepOneScreenReaderLabel"
                            >
                                {{ setUpOnlineAccessListItem }}
                            </div>

                            <div
                                *ngIf="(isInformationOnly$ | async) === true"
                                class="c11n-text-md-bold col-lg-10 step"
                                [ngClass]="
                                    setClassForInfoOnlyStepTwoSpacing(
                                        isSmallView$ | async,
                                        isMobileView$ | async,
                                        isTabletLargeView$ | async,
                                        isTabletXLargeView$ | async,
                                        isTabletView$ | async
                                    )
                                "
                                data-cy="log-in-and-enter-pin-list-item-info-only"
                                [aria-label]="stepTwoInfoOnlyScreenReaderLabel"
                            >
                                {{ logInAndEnterPinListItem }}
                            </div>

                            <div
                                *ngIf="(isInformationOnly$ | async) === false"
                                class="c11n-text-md-bold col-lg-10 step"
                                data-cy="log-in-and-enter-pin-list-item-limited"
                                [aria-label]="stepTwoLimitedAccessScreenReaderLabel"
                            >
                                {{ logInAndEnterPinListItem }}
                            </div>

                            <div
                                *ngIf="(isInformationOnly$ | async) === false"
                                class="c11n-text-md col-lg-10 not-active-step step"
                                data-cy="accept-access-request-list-item"
                                [aria-label]="stepThreeScreenReaderLabel"
                            >
                                {{ acceptAccessRequestListItem }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        class="row d-flex justify-content-center g-0 mx-auto c11n-space-stack-10x c11n-space--force"
    >
        <div class="col-sm-12 col-md-12 col-lg-6">
            <c11n-button
                buttonType="button"
                size="medium"
                variant="primary"
                labelText="Log in"
                data-cy="login-button"
                [fullWidth]="isMobileView$ | async"
                (clickEvent)="loginButtonClick()"
            ></c11n-button>
        </div>
    </div>
</div>
